import React from 'react';
import { useParams } from 'react-router-dom';
import { useRestaurantBySlug } from '../hooks/useRestaurantBySlug';
import RestaurantDetailView from './RestaurantDetailView';

// /restaurant/:slug — restaurant detail resolved by slugified name (the
// canonical, SEO-facing URL). Resolution differs from /place/:placeId, but the
// rendered page is identical — see RestaurantDetailView.
const RestaurantDetailPage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const { detail, isLoaded, error } = useRestaurantBySlug(slug);

  return <RestaurantDetailView detail={detail} isLoaded={isLoaded} error={error} />;
};

export default RestaurantDetailPage;
